exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".service-message[data-v-7913ab15]{font-family:Roboto,sans-serif;font-weight:400;font-size:16px;line-height:1.5em;color:#a6aab4;max-width:620px;margin:0 0 40px}.service-message p[data-v-7913ab15]{margin:0}", ""]);

// exports
